import { Banner } from "@shopify/polaris"
import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"

const ViewerOnlyBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner
      title={t(`collect:questions.common.banner.reader_only.title`)}
      status="warning"
    >
      {t(`collect:questions.common.banner.reader_only.description`)}
    </Banner>
  )
}

ViewerOnlyBanner.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
}

export default ViewerOnlyBanner
